import React from 'react';
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';
// dropUp opens the calendar above the input, for fields that sit low enough in a
// form that the default downward picker would be clipped. Styled in src/index.css.
const InputDatetime=({value,dateFormat,timeFormat, onChange,timeConstraints, inputProps, dropUp})=>{
    return (
        <Datetime
            className={dropUp?'rdt-drop-up':undefined}
            value={value}
            inputProps={inputProps}
            dateFormat={dateFormat}
            timeFormat={timeFormat}
            onChange={onChange}
            timeConstraints={timeConstraints}
        />
    )
}
export default InputDatetime;